module.exports = __webpack_public_path__ + "static/media/2025_aycm_msp.5444a638.png";